module.exports = __webpack_public_path__ + "img/glossary-manhole.6b556c62.png";